import { Currency, type Dtos, formatToDollar, SuretyBondTermPaymentStatus } from "@inrev/common";
import { Icon, Text } from "../../primitives";
import { Tag, type TagColor } from "../../ui/Tag";

type BondTerm = Dtos.SuretyBondTerm.Get.Response;

const paymentStatusColors: Record<SuretyBondTermPaymentStatus, TagColor> = {
	[SuretyBondTermPaymentStatus.Paid]: "green",
	[SuretyBondTermPaymentStatus.Unpaid]: "yellow",
	[SuretyBondTermPaymentStatus.Waived]: "gray",
};

export const formatSignedDollars = (amount: Currency) =>
	`${amount >= Currency.ZERO ? "+" : ""}${formatToDollar(amount)}`;

export const SignedDollars = ({
	amount,
	type,
}: {
	amount: Currency;
	type: "body" | "body-strong";
}) => (
	<Text className="tabular-nums" color={amount < 0 ? "warning" : "primary"} truncate type={type}>
		{formatSignedDollars(amount)}
	</Text>
);

export const PaymentStatusTag = ({ status }: { status: SuretyBondTermPaymentStatus }) => (
	<Tag border className="gap-1" color={paymentStatusColors[status]}>
		{status === SuretyBondTermPaymentStatus.Paid && <Icon aria-hidden size="micro" type="check" />}
		{SuretyBondTermPaymentStatus.displayName(status)}
	</Tag>
);

export const TermStatusTag = ({ term }: { term: BondTerm }) => {
	if (term.status === "future") {
		return (
			<Tag border color="gray">
				Future term
			</Tag>
		);
	}

	if (term.unpaidCount > 0) {
		return (
			<Tag border className="gap-1" color="yellow">
				<Icon aria-hidden size="micro" type="exclamation-triangle" />
				Unpaid ({term.unpaidCount})
			</Tag>
		);
	}

	return <PaymentStatusTag status={term.paymentStatus} />;
};
